import { AppThunk } from '../../../store/rootReducer';
import { getBaseProperties, track } from '../analytics.utils';
import { CHANGE_LEAD_PLOT_UNIT } from '../analytics.constants';
import { BPM, MS } from '../../layout/types/layout-state.type';

export const trackLeadPlotUnitChange =
  (
    name: typeof CHANGE_LEAD_PLOT_UNIT,
    showBpm: boolean,
    analyticsEventTrack = track,
  ): AppThunk =>
  (_, getState) => {
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    analyticsEventTrack({
      name,
      properties: {
        ecg_id: ecgId,
        user_id: userId,
        view,
        new_unit: showBpm ? BPM : MS,
        previous_unit: showBpm ? MS : BPM,
      },
    });
  };
